/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ConvertOptionsComponent } from '../../components/workspace/convert-options/convert-options.component';
import { ConvertOptions } from '../../models/convert-options-info';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class CovertSystemDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    const convertOptions = new ConvertOptions();
    sysquePopupConfig.component = ConvertOptionsComponent;
    convertOptions.systemName = 'My Convert System';
    sysquePopupConfig.data = convertOptions;
    sysquePopupConfig.component.data = sysquePopupConfig.data;
    sysquePopupConfig.width = 641;
    sysquePopupConfig.height = 678;
    sysquePopupConfig.componentTitle = 'Convert System';
  }
}
